import React, { Fragment } from 'react'
import WithIcon from './WithIcon'
import WithoutIcon from './WithoutIcon'
import { DescriptionProps } from './interfaces'

export default function Description({
  icon,
  title,
  description,
  width,
  height,
  background,
  textColor,
  borderColor,
  size,
}: DescriptionProps) {
  return (
    <Fragment>
      {icon ? (
        <WithIcon
          icon={icon}
          title={title}
          description={description}
          width={width}
          height={height}
          background={background}
          textColor={textColor}
          borderColor={borderColor}
          size={size}
        />
      ) : (
        <WithoutIcon title={title} description={description} />
      )}
    </Fragment>
  )
}
